import { mapGetters } from 'vuex';
import configMixin from './configMixin';

export default {
  mixins: [configMixin],
  computed: {
    ...mapGetters({
      conversationParams: 'conversationAttributes/getConversationParams',
    }),
    isAssistantAttached() {
      return typeof window.hooryWebChannel.assistantType !== 'undefined';
    },
    shouldHideBottomInput() {
      const { assistantType } = window.hooryWebChannel;
      const { status, customAttributes, in_queue } = this.conversationParams;
      const { connectedToSupport, forwardToAI } = customAttributes || {};

      if (in_queue && !this.allowMessageWhenUserQueued) return true;
      if (connectedToSupport || forwardToAI) return false;

      return (
        assistantType === 'rule-based' && (!status || status === 'pending')
      );
    },
    isRulebasedAnswering() {
      const { assistantType } = window.hooryWebChannel;
      if (assistantType !== 'rule-based') return false;

      const { customAttributes } = this.conversationParams;
      const { connectedToSupport, forwardToAI } = customAttributes || {};

      if (connectedToSupport || forwardToAI) return false;

      return true;
    },
  },
};
